import { render } from "./Breeding.vue?vue&type=template&id=30fc19f0&scoped=true&ts=true"
import script from "./Breeding.vue?vue&type=script&lang=ts"
export * from "./Breeding.vue?vue&type=script&lang=ts"

import "./Breeding.vue?vue&type=style&index=0&id=30fc19f0&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fc19f0"]])

export default __exports__